import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import clientService from "../services/clientService";
import entrepotservice from "../services/entrepotService";

const initialState = {
    entrepots: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 5, // Size of each page
    isAdded: false, // Flag to indicate if a new client has been added
    receptions: [],
    deliveries: [],

};

const entrepotSlice = createModule({
    name: 'entrepots',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        addEntrepot: (state) => {
            state.loading = true;
        },
        updateEntrepot: (state) => {
            state.loading = true;
        },
        getLatestReceptions: (state) => {
            state.loading = true;
        },
        getLatestDeliveries: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.entrepots = payload.content || [];
            // state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            // state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            // state.pageNumber = payload.body.pageNumber;
        },
        fetchedReceptions: (state, payload) => {
            state.loading = false;
            state.receptions = payload;
        },
        fetchedDeliveries: (state, payload) => {
            state.loading = false;
            state.deliveries = payload;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },

    },
    sagas: (A) => ({
        *[A.list]() {
            try {
                const { data } = yield call(entrepotservice.list);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.getLatestReceptions]({payload}) {
            try {
                const { data } = yield call(entrepotservice.getLatestReceptions, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedReceptions(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.getLatestDeliveries]({payload}) {
            try {
                const { data } = yield call(entrepotservice.getLatestDeliveries, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedDeliveries(data));
            }
            catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError())
            }
        },
        *[A.addEntrepot]({ payload }) {
            try {
                const { data } = yield call(entrepotservice.addEntrepot, payload.data);
                yield put(A.finishFetching());
                yield put(A.list());
                yield call(payload.onSuccess(data.body));
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
            }
        },
        *[A.updateEntrepot]({ payload }) {
            try {
                const { data } = yield call(entrepotservice.update, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.inactivate]({ payload }) {
            try {
                yield call(clientService.inactivate, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.generatePdfReleve]({ payload }) {
            try {
                const pdfData = yield call(clientService.generatePDFReleve, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
    }),
});

export default entrepotSlice;
export const entrepotActions = entrepotSlice.actions;